// TODO - Type 'any' needs to be fixed.
export const resetCreateDraftShiftAsyncStateReducer = (state:any) => {
	state.createDraftShiftAsync.status = "idle";
	state.createDraftShiftAsync.errorMessage = "";
};
